import _typeof from "@babel/runtime/helpers/esm/typeof";
export function addPx(input) {
  if (typeof input === "number") {
    return "".concat(input, "px");
  } else if (typeof input === "string") {
    return input.endsWith("px") ? input : "".concat(input, "px");
  } else if (Array.isArray(input)) {
    return input.map(addPx);
  } else if (_typeof(input) === "object" && input !== null) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix
    var result = {};
    for (var key in input) {
      if (Object.prototype.hasOwnProperty.call(input, key)) {
        result[key] = addPx(input[key]);
      }
    }
    return result;
  } else {
    throw new Error("Unsupported input type");
  }
}